exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-calendar-text[data-v-8d83e14c]{text-align:center}.page-calendar-text_nothing[data-v-8d83e14c]{color:#999;font-size:12px;padding:0 15px}.page-calendar-text_done[data-v-8d83e14c],.page-calendar-text_ready[data-v-8d83e14c],.page-calendar-text_waiting[data-v-8d83e14c]{text-transform:uppercase;font-weight:700;font-size:13px;line-height:125%;padding-bottom:10px}.page-calendar-text_waiting[data-v-8d83e14c]{color:#6c6}.page-calendar-text_ready[data-v-8d83e14c]{color:#222}.page-calendar-text_done[data-v-8d83e14c]{color:#333254}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8d83e14c","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/calendar/text/component.vue
// module id = 65ce19d7fe9e2bc86b9e
// module chunks = 0